<template>
  <v-data-table
    v-bind="$attrs"
    :headers="translatedHeaders"
    :items-per-page="$attrs['items-per-page'] !== undefined ? $attrs['items-per-page'] : -1"
    :no-data-text="$bct(noDataText)"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData || {}"
      />
    </template>
  </v-data-table>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  headers: {
    type: Array,
    default: () => [],
  },
  noDataText: {
    type: String,
    default: 'No data found',
  },
});

const translatedHeaders = computed(() => {
  return props.headers.map((header) => {
    const updatedHeader = { ...header };
    if (header.title) {
      updatedHeader.title = $bct(header.title);
    }
    return updatedHeader;
  });
});
</script>
